import { RouteObject } from "react-router"
import PacienteList from "./view/paciente.list"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../config/data.types"
import { PeopleOutline } from "@mui/icons-material"
import store from "../../store"
import { pacienteController } from "./paciente.controller"

export enum PathRotaPaciente {
    paciente = "/paciente"
}

const routerPaciente: RouteObject = {
    path: PathRotaPaciente.paciente,
    element: <PacienteList/>,
}


export const navigationToPacienteView = ()=> {
    rotas.navigate(PathRotaPaciente.paciente)
    store.dispatch(pacienteController.reducer.actions.read())
}

export function startRouterPaciente(){
    const menu:MainMenu = {
        text:"Pacientes",
        icon:<PeopleOutline />,
        eventOnClick:navigationToPacienteView
    }
    menuRotas.push(menu);
    return routerPaciente
}

export const handleShowModalSelectPaciente = () => {
    store.dispatch(pacienteController.reducer.actions.setShowSelectModal(true));
    if(pacienteController.state.rows.length === 0)
        store.dispatch(pacienteController.reducer.actions.read())
}